<template>
	<div v-if="option.series[0].data[0].name != ''" id="test" :options="option" @click="onClickBuble">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center">Loading content, please wait</v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular :size="70" :width="7" color="#0471A5" indeterminate></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialog = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
	<div v-else id="test" :options="option" @click="onClickBuble">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center">Loading content, please wait</v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular :size="70" :width="7" color="#0471A5" indeterminate></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialog = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
	import HighCharts from 'highcharts';
	import highchartsMore from 'highcharts/highcharts-more';
	highchartsMore(HighCharts);
  import axios from "axios"
	export default {
    props: {
      selectedTopic: null,
      selectedPeriode: null,
      statusFilter: null,
      isClickBuble: null,
      resetcolorClicked: null,
      updateSocket: null
    },
		data() {
			return {
        isClickBubleOrg: "",
        colorClicked: "",
				id: 'test',
        dialog: false,
        kontenBerita: [],
        mediaBerita: [],
        MediatwitterShare: [],
        MediaYtShare: [],
        SetOrganisasi: [],
        chart_data_sort_organization: [],

        pageplay: 100,

				option: {
					chart: {
						type: 'packedbubble',
						height: '500px'
					},
					title: {
            text: null
          },
					tooltip: {
						enabled: false
					},
					legend: {
						enabled: false
					},
					credits: {
						enabled: false
					},
          series: [
            {
              data: [{
                value: 0,
                name: ''
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'gray'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'pink'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'yellow'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'green'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'purple'
              }]
            },
          ],

					plotOptions: {
						packedbubble: {
							minSize: '40%',
							maxSize: '120%',
							zMin: 0,
							zMax: 1000,
							layoutAlgorithm: {
								splitSeries: false,
								gravitationalConstant: 0.02
							},
							dataLabels: {
                enabled: true,
                format: '{point.name}',
                useHTML: true,
                style: {
                  textAlign: 'center',
                  textOverflow: 'clip',
                  width: 100,
                  color: 'black',
                  textOutline: 'none',
                  fontWeight: 'normal'
                },
							}
						}
					},
				},
			}
		},
		mounted() {
			// this.option.series = this.seriesData;
      HighCharts.chart(this.id, this.option);
    },
		updated(){
			HighCharts.chart(this.id, this.option);
		},
    methods: {
      onClickBuble(event){
        this.isClickBubleOrg = event.point.name
        console.log(event.point.color)
        this.colorClicked = event.point.color
        this.$emit('clickedOrg', this.isClickBubleOrg)
      },
      async loadKontenBerita(){
        console.log('clicked')
        // alert('aa');
        this.mediaBerita = []
        this.MediatwitterShare = []
        this.MediaYtShare = []
        console.log("Organisasi Component")
        this.mediaBerita = []
        this.MediatwitterShare = []
        this.MediaYtShare = []
        HighCharts.chart(this.id, this.option);

        console.log(this.updateSocket)
        if(this.updateSocket == false){
          this.dialog = true
        }
        try {
          this.topic2 = this.selectedTopic2;
          if (this.selectedTopic2 == undefined) {
            this.topic2 = ''
          }
          let sentiment_search = this.$store.sentiment_glob
          if (this.$store.sentiment_glob == '' || this.$store.sentiment_glob == undefined) {
            sentiment_search = ""
          }
          let ner_person_search = this.$store.ner_person_glob
          if (this.$store.ner_person_glob == '' || this.$store.ner_person_glob == undefined) {
            ner_person_search = ""
          }
          let ner_organization_search = this.$store.ner_organization_glob
          if (this.$store.ner_organization_glob == '' || this.$store.ner_organization_glob == undefined) {
            ner_organization_search = ""
          }
          let object_filter_logika = this.$store.finalobjectfilterlogika_glob
          if (this.$store.finalobjectfilterlogika_glob == "" || this.$store.finalobjectfilterlogika_glob == undefined) {
            object_filter_logika = ""
          }
          const data1 = await axios
            .get("solr-new?start_date=" + this.$store.date_start_glob + "&end_date=" + this.$store.date_end_glob + "&topic=" + this.$store.topic_glob + "&topic2=" + this.$store.topic_glob2 + "&sentiment=" + sentiment_search + "&ner_person=" + ner_person_search + "&ner_organization=" + ner_organization_search + "&logic=" + JSON.stringify(object_filter_logika) + "&start=0&rows=" + this.pageplay)
          const data = data1.data;
          console.log(data.data)
          if(this.statusFilter == "Negative"){
            data.data = data.data.filter(function (el) {
              return el.sentiment == "Negative";
            });
          }
          if(this.statusFilter == "Postive"){
            data.data = data.data.filter(function (el) {
              return el.sentiment == "Postive";
            });
          }
          if(this.statusFilter == "Netral"){
            data.data = data.data.filter(function (el) {
              return el.sentiment == "Netral";
            });
          }
          this.kontenBerita = data1.data
          console.log(data1.data)

          if(this.isClickBuble == ''){
            const organisasi = []
            const organisasi2 = []
            data.data.forEach((element) => {
              if(element["ner_organization"] != '' && element["ner_organization"] != null){
                organisasi.push(element["ner_organization"]);
                organisasi2.push(element["ner_organization"]);
              }
            });
            const SetttOrganisasi = []
            const SetttOrganisasi2 = []
            for (let i = 0; i < organisasi.length; i++) {
              SetttOrganisasi.push(organisasi[i].at(-0))
              SetttOrganisasi2.push(organisasi2[i].at(-1))
            }

            const Setorganisasi = [...new Set(SetttOrganisasi)]
            const Setorganisasi2 = [...new Set(SetttOrganisasi2)]
            const Setorganisasi3 = Setorganisasi.concat(Setorganisasi2)

            this.SetOrganisasi = [...new Set(Setorganisasi3)]

            this.chart_data_sort_organization = []
            for (let x = 0; x < this.SetOrganisasi.length; x++) {
              var jum1 = 0;
              for (let i = 0; i < data.data.length; i++) {
                if (data.data[i].ner_organization != null) { //tambahan karna data ada yang null
                  if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){ //tambahan karna data ada yang null
                    if (data.data[i].ner_organization[0] == this.SetOrganisasi[x]) {
                      jum1++;
                    }
                  }
                  if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){ //tambahan karna data ada yang null
                    if (data.data[i].ner_organization[1] == this.SetOrganisasi[x]) {
                      jum1++;
                    }
                  }
                }
              }

              this.chart_data_sort_organization.push({
                'name_org' : this.SetOrganisasi[x],
                'name_org_value' : jum1
              })
            }
            this.chart_data_sort_organization.sort(function(a,b){ // sort desc value
              return (b.name_org_value) - (a.name_org_value);
            });
            for (let i = 0; i < 6; i++) {
              this.option.series[i].data[0].name = ""
              this.option.series[i].data[0].value = 0
            }
            if(this.SetOrganisasi.length == 0){
              for (let i = 0; i < 6; i++) {
                this.option.series[i].data[0].name = ""
                this.option.series[i].data[0].value = 0
              }
            }
          }
          if(this.SetOrganisasi.length != 0){
            for (let x = 0; x < this.chart_data_sort_organization.length; x++) {
              if(x < 6){
                this.option.series[x].data[0].name = this.chart_data_sort_organization[x].name_org
                this.option.series[x].data[0].value = Math.ceil(300 / this.option.series.length * this.chart_data_sort_organization[x].name_org_value)
              }
            }
          }
          if(this.colorClicked != ""){
            this.option.series[0].data[0].color = "#013b73"
            this.option.series[1].data[0].color = "#d4d4fa"
            this.option.series[2].data[0].color = "#ffcfee"
            this.option.series[3].data[0].color = "#fcf8b8"
            this.option.series[4].data[0].color = "#bdfcb6"
            this.option.series[5].data[0].color = "#e8b3fc"
            console.log('test1')
          }
          if(this.colorClicked != "" && this.isClickBubleOrg != this.option.series[0].data[0].name){
            for (let index = 0; index < this.option.series.length; index++) {
              if(this.option.series[index].data[0].name == this.isClickBubleOrg){
                this.option.series[index].data[0].color = "#013b73"
                this.option.series[0].data[0].color = '#bbdcfc'
                console.log('test2')
              }
            }
            console.log('test3')
          }
          if(this.resetcolorClicked == true){
            this.option.series[0].data[0].color = "#7cb5ec"
            this.option.series[1].data[0].color = "gray"
            this.option.series[2].data[0].color = "pink"
            this.option.series[3].data[0].color = "yellow"
            this.option.series[4].data[0].color = "green"
            this.option.series[5].data[0].color = "purple"
            console.log('test4')
          }
          this.dialog = false
          this.updateSocket = false
        } catch(e) {
          this.dialog = true;
          console.log('error')
          console.log(e)
        }
      },
      async loadSentimentanalysisBerita(){
        this.mediaBerita = []
        this.dialog = true
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
        try {
          for (let i = 0; i < this.kontenBerita.length; i++) {
            if (this.kontenBerita[i].source == 'berita') {
              this.mediaBerita.push(this.kontenBerita[i]);
            }
          }
          const organisasi = []
          const organisasi2 = []
          this.mediaBerita.forEach((element) => {
            if(element["ner_organization"] != '' && element["ner_organization"] != null){
              organisasi.push(element["ner_organization"]);
              organisasi2.push(element["ner_organization"]);
            }
          });
          const SetttOrganisasi = []
          const SetttOrganisasi2 = []
          for (let i = 0; i < organisasi.length; i++) {
            SetttOrganisasi.push(organisasi[i].at(-0))
            SetttOrganisasi2.push(organisasi2[i].at(-1))
          }

          const Setorganisasi = [...new Set(SetttOrganisasi)]
          const Setorganisasi2 = [...new Set(SetttOrganisasi2)]
          const Setorganisasi3 = Setorganisasi.concat(Setorganisasi2)

          this.SetOrganisasi = [...new Set(Setorganisasi3)]

          this.chart_data_sort_organization = []
          for (let x = 0; x < this.SetOrganisasi.length; x++) {
            var jum1 = 0;
            for (let i = 0; i < this.mediaBerita.length; i++) {
              if (this.mediaBerita[i].ner_organization != null) { //tambahan karna data ada yang null
                if(this.mediaBerita[i].ner_organization[0] != '' && this.mediaBerita[i].ner_organization[0] != null){ //tambahan karna data ada yang null
                  if (this.mediaBerita[i].ner_organization[0] == this.SetOrganisasi[x]) {
                    jum1++;
                  }
                }
                if(this.mediaBerita[i].ner_organization[1] != '' && this.mediaBerita[i].ner_organization[1] != null){ //tambahan karna data ada yang null
                  if (this.mediaBerita[i].ner_organization[1] == this.SetOrganisasi[x]) {
                    jum1++;
                  }
                }
              }
            }

            this.chart_data_sort_organization.push({
              'name_org' : this.SetOrganisasi[x],
              'name_org_value' : jum1
            })
          }
          this.chart_data_sort_organization.sort(function(a,b){ // sort desc value
            return (b.name_org_value) - (a.name_org_value);
          });
          if(this.SetOrganisasi.length == 0){
            for (let i = 0; i < 6; i++) {
              this.option.series[i].data[0].name = ""
              this.option.series[i].data[0].value = 0
            }
          }
          if(this.SetOrganisasi.length != 0){
            for (let x = 0; x < this.chart_data_sort_organization.length; x++) {
              if(x < 6){
                this.option.series[x].data[0].name = this.chart_data_sort_organization[x].name_org
                this.option.series[x].data[0].value = Math.ceil(300 / this.option.series.length * this.chart_data_sort_organization[x].name_org_value)
              }
            }
          }
        } catch (e) {
          console.log('error')
        }
      },
      async loadSentimentTweet(){
        this.MediatwitterShare = []
        HighCharts.chart(this.id, this.option);
        this.dialog = true
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
        try {
          for (let i = 0; i < this.kontenBerita.length; i++) {
            if (this.kontenBerita[i].source == 'twitter') {
              this.MediatwitterShare.push(this.kontenBerita[i]);
            }
          }
          const organisasi = []
          const organisasi2 = []
          this.MediatwitterShare.forEach((element) => {
            if(element["ner_organization"] != '' && element["ner_organization"] != null){
              organisasi.push(element["ner_organization"]);
              organisasi2.push(element["ner_organization"]);
            }
          });
          const SetttOrganisasi = []
          const SetttOrganisasi2 = []
          for (let i = 0; i < organisasi.length; i++) {
            SetttOrganisasi.push(organisasi[i].at(-0))
            SetttOrganisasi2.push(organisasi2[i].at(-1))
          }

          const Setorganisasi = [...new Set(SetttOrganisasi)]
          const Setorganisasi2 = [...new Set(SetttOrganisasi2)]
          const Setorganisasi3 = Setorganisasi.concat(Setorganisasi2)

          this.SetOrganisasi = [...new Set(Setorganisasi3)]

          this.chart_data_sort_organization = []
          for (let x = 0; x < this.SetOrganisasi.length; x++) {
            var jum1 = 0;
            for (let i = 0; i < this.MediatwitterShare.length; i++) {
              if (this.MediatwitterShare[i].ner_organization != null) { //tambahan karna data ada yang null
                if(this.MediatwitterShare[i].ner_organization[0] != '' && this.MediatwitterShare[i].ner_organization[0] != null){ //tambahan karna data ada yang null
                  if (this.MediatwitterShare[i].ner_organization[0] == this.SetOrganisasi[x]) {
                    jum1++;
                  }
                }
                if(this.MediatwitterShare[i].ner_organization[1] != '' && this.MediatwitterShare[i].ner_organization[1] != null){ //tambahan karna data ada yang null
                  if (this.MediatwitterShare[i].ner_organization[1] == this.SetOrganisasi[x]) {
                    jum1++;
                  }
                }
              }
            }

            this.chart_data_sort_organization.push({
              'name_org' : this.SetOrganisasi[x],
              'name_org_value' : jum1
            })
          }
          this.chart_data_sort_organization.sort(function(a,b){ // sort desc value
            return (b.name_org_value) - (a.name_org_value);
          });
          if(this.SetOrganisasi.length == 0){
            for (let i = 0; i < 6; i++) {
              this.option.series[i].data[0].name = ""
              this.option.series[i].data[0].value = 0
            }
          }
          if(this.SetOrganisasi.length != 0){
            for (let x = 0; x < this.chart_data_sort_organization.length; x++) {
              if(x < 6){
                this.option.series[x].data[0].name = this.chart_data_sort_organization[x].name_org
                this.option.series[x].data[0].value = Math.ceil(300 / this.option.series.length * this.chart_data_sort_organization[x].name_org_value)
              }
            }
          }
        } catch (e) {
          console.log('error')
        }
      },
      async loadSentimentYt(){
        this.MediaYtShare = []
        HighCharts.chart(this.id, this.option);
        this.dialog = true
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
        try {
          for (let i = 0; i < this.kontenBerita.length; i++) {
            if (this.kontenBerita[i].source == 'youtube') {
              this.MediaYtShare.push(this.kontenBerita[i]);
            }
          }
          const organisasi = []
          const organisasi2 = []
          this.MediaYtShare.forEach((element) => {
            if(element["ner_organization"] != '' && element["ner_organization"] != null){
              organisasi.push(element["ner_organization"]);
              organisasi2.push(element["ner_organization"]);
            }
          });
          const SetttOrganisasi = []
          const SetttOrganisasi2 = []
          for (let i = 0; i < organisasi.length; i++) {
            SetttOrganisasi.push(organisasi[i].at(-0))
            SetttOrganisasi2.push(organisasi2[i].at(-1))
          }

          const Setorganisasi = [...new Set(SetttOrganisasi)]
          const Setorganisasi2 = [...new Set(SetttOrganisasi2)]
          const Setorganisasi3 = Setorganisasi.concat(Setorganisasi2)

          this.SetOrganisasi = [...new Set(Setorganisasi3)]

          this.chart_data_sort_organization = []
          for (let x = 0; x < this.SetOrganisasi.length; x++) {
            var jum1 = 0;
            for (let i = 0; i < this.MediaYtShare.length; i++) {
              if (this.MediaYtShare[i].ner_organization != null) { //tambahan karna data ada yang null
                if(this.MediaYtShare[i].ner_organization[0] != '' && this.MediaYtShare[i].ner_organization[0] != null){ //tambahan karna data ada yang null
                  if (this.MediaYtShare[i].ner_organization[0] == this.SetOrganisasi[x]) {
                    jum1++;
                  }
                }
                if(this.MediaYtShare[i].ner_organization[1] != '' && this.MediaYtShare[i].ner_organization[1] != null){ //tambahan karna data ada yang null
                  if (this.MediaYtShare[i].ner_organization[1] == this.SetOrganisasi[x]) {
                    jum1++;
                  }
                }
              }
            }

            this.chart_data_sort_organization.push({
              'name_org' : this.SetOrganisasi[x],
              'name_org_value' : jum1
            })
          }
          this.chart_data_sort_organization.sort(function(a,b){ // sort desc value
            return (b.name_org_value) - (a.name_org_value);
          });
          if(this.SetOrganisasi.length == 0){
            for (let i = 0; i < 6; i++) {
              this.option.series[i].data[0].name = ""
              this.option.series[i].data[0].value = 0
            }
          }
          if(this.SetOrganisasi.length != 0){
            for (let x = 0; x < this.chart_data_sort_organization.length; x++) {
              if(x < 6){
                this.option.series[x].data[0].name = this.chart_data_sort_organization[x].name_org
                this.option.series[x].data[0].value = Math.ceil(300 / this.option.series.length * this.chart_data_sort_organization[x].name_org_value)
              }
            }
          }
        } catch (e) {
          console.log('error')
        }
      },
    },
	};
</script>